import { Button, Row } from "antd";
import { useCallback, useMemo } from "react";
import { usePermissions } from "../../../../../../../../lib/hooks/usePermissions";

type TBtnsProps = {
  currentId: string | null;
  onSaveClick: (isNew: boolean, currentId: string | null) => Promise<void>;
  onSaveAndPrint: (currentId: string) => Promise<void>;
  onCancelClick: () => void;
  onDeleteClick: (id: string) => void;
  isFormDisabled: boolean;
};

export const FormButtons = ({
  currentId,
  onSaveClick,
  onSaveAndPrint,
  onCancelClick,
  onDeleteClick,
  isFormDisabled,
}: TBtnsProps) => {
  const onDelete = useCallback(
    () => onDeleteClick(currentId || ""),
    [currentId, onDeleteClick]
  );

  const { hasAccess } = usePermissions();

  const isCloseDisabled: boolean = useMemo(() => {
    if (hasAccess("Payoffs", currentId !== null ? "Modify" : "Add")) {
      return isFormDisabled;
    }

    return false;
  }, [currentId, hasAccess, isFormDisabled]);

  return (
    <Row className="default-form-buttons w-100 pa-6 divider justify-space-between position-absolute">
      <Row className="default-form-buttons-main">
        {hasAccess("Payoffs", currentId !== null ? "Modify" : "Add") && (
          <Button
            shape="round"
            type="primary"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={() => onSaveClick(false, currentId)}
          >
            {currentId !== null ? "Save" : "Add"}
          </Button>
        )}

        {currentId !== null &&
          hasAccess("ContractMailings", "Send") &&
          hasAccess("Payoffs", "Modify") && (
            <Button
              shape="round"
              disabled={isFormDisabled}
              loading={isFormDisabled}
              onClick={() => onSaveAndPrint(currentId)}
            >
              Save & Print
            </Button>
          )}

        {currentId === null && hasAccess("Payoffs", "Add") && (
          <Button
            shape="round"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={() => onSaveClick(true, currentId)}
          >
            Add & New
          </Button>
        )}
        <Button
          shape="round"
          disabled={isCloseDisabled}
          onClick={onCancelClick}
        >
          Cancel
        </Button>
      </Row>
      <Row>
        {currentId !== null && hasAccess("Payoffs", "Delete") && (
          <Button type="link" disabled={isFormDisabled} onClick={onDelete}>
            Delete
          </Button>
        )}
      </Row>
    </Row>
  );
};
